/**
 * @module shared/payment-card
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const SAVED_PAYMENT_CARD_CONSTANTS = {
  PAYMENT_MODULE: 'PaymentModule',
  PAYMENT_CARD_COMPONENT: 'PaymentCardComponent',
  SUPPORTED: 'Supported',
  CARD_TYPE_HYBRID: 'hybrid',
  CARD_TYPE_CREDIT: 'credit',
  ANON: 'ANON',
  CARE: 'care',
  DEBIT_CARD: 'Debit',
  DEBIT: 'debit',
};
